import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'app-formly-wrapper-section',
    imports: [
        CommonModule,
        ReactiveFormsModule
    ],
    template: `
    <div [class]="props['htmlClass'] || ''">
        <ng-container #fieldComponent></ng-container>
    </div>
  `
})
export class SectionWrapperComponent extends FieldWrapper {
}
